import React, {useEffect} from 'react';
import {Bell} from "react-feather";
import {getBrokerReminders} from "../../services/api/broker";
import RemindersWrap from "./Brokers/Reminders";

const NavReminders = () => {
    const [remindersData, setRemindersData] = React.useState([1]);
    const [isOpened, setIsOpened] = React.useState(false);

    const getReminders = async () => {
        try {
            const data = await getBrokerReminders();
            setRemindersData(data);
        } catch (e) {
            console.log(e)
        }
    }

    useEffect(() => {
        getReminders().then(r => console.log(r));
    }, []);

    return (
        <div className="sl-btn-link-gray sl-p-2-point-5 sl-mr-4 sl-relative sl-z-10">
            <Bell className={"sl-cursor-pointer"} onClick={() => setIsOpened(!isOpened)}/>
            {remindersData.count > 0 && (
                <span
                    className="sl-flex sl-justify-center sl-align-center sl-absolute sl-top-0 sl-right-0 sl-rounded-full sl-h-5 sl-w-5 sl-bg-error-600 sl-text-white sl-text-xs sl-font-medium">
                    {remindersData.count}
                </span>
            )}
            {isOpened && (<RemindersWrap remindersData={remindersData} onClose={() => setIsOpened(false)}/>)}
        </div>
    );
};

export default NavReminders;
